import React from 'react';
import { ChatToolsContainer } from './chat-tools/index.tsx';
import { DeprecatedCountsContainer } from './deprecated-counts/index.tsx';
import { IncidentsContainer } from './incidents/index.tsx';
import { IntegrationsContainer } from './integrations/index.tsx';
import { JNAAppStatusContainer } from './jna-app-status/index.tsx';
import { TeamAdminStatusContainer } from './team-admin-status/index.tsx';
import { TeamsContainer } from './teams/index.tsx';
import { TransitioningStatusContainer } from './transitioning-status/index.tsx';
import { UsersAndRolesContainer } from './users-and-roles/index.tsx';

const MinimalToolingProviders = ({ children }: { children: React.ReactNode }) => (
	<UsersAndRolesContainer isGlobal>
		<ChatToolsContainer isGlobal>
			<JNAAppStatusContainer isGlobal>
				<TransitioningStatusContainer isGlobal>{children}</TransitioningStatusContainer>
			</JNAAppStatusContainer>
		</ChatToolsContainer>
	</UsersAndRolesContainer>
);

export const ChangeboardingProviders = ({ children }: { children: React.ReactNode }) => {
	return (
		<TeamsContainer isGlobal>
			<TeamAdminStatusContainer isGlobal>
				<IntegrationsContainer isGlobal>
					<DeprecatedCountsContainer isGlobal>
						<IncidentsContainer isGlobal>
							<MinimalToolingProviders>{children}</MinimalToolingProviders>
						</IncidentsContainer>
					</DeprecatedCountsContainer>
				</IntegrationsContainer>
			</TeamAdminStatusContainer>
		</TeamsContainer>
	);
};
